// components/Header.js - Update the menu items
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = ({ title }) => {
  const { currentUser, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      <button className={`hamburger-button ${menuOpen ? 'active' : ''}`} onClick={toggleMenu}>
        <div className="hamburger-icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      {menuOpen && (
        <>
          <div className="menu-overlay" onClick={toggleMenu}></div>
          <div className="slide-menu">
            <div className="menu-header">
              <h3>Menu</h3>
              <button className="close-menu" onClick={toggleMenu}>✕</button>
            </div>
            
            {currentUser && (
              <div className="menu-user-info">
                <div className="menu-user-avatar">👤</div>
                <div className="menu-user-details">
                  <span className="menu-user-name">{currentUser.displayName || currentUser.email}</span>
                  <span className="menu-user-phone">{currentUser.phoneNumber || ''}</span>
                </div>
              </div>
            )}
            
            <div className="menu-items">
              {/* ADDED: Medications option */}
              <Link to="/trackmed2" className="menu-item" onClick={toggleMenu}>
                <span className="menu-icon">💊</span>
                Medications
              </Link>
              
              <Link to="/about" className="menu-item" onClick={toggleMenu}>
                <span className="menu-icon">ℹ️</span>
                About
              </Link>
              
              <Link to="/support" className="menu-item" onClick={toggleMenu}>
                <span className="menu-icon">📞</span>
                Support
              </Link>
              
              <div className="menu-divider"></div>
              
              <button onClick={handleLogout} className="menu-item logout-item">
                <span className="menu-icon">🚪</span>
                Logout
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;